import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'wonderbly-components/lib/Grid';
import Collapsible from '../Collapsible';
import LinkSet from './LinkSet';
import PaymentIcons from '../PaymentIcons';
import SocialNetworks from './SocialNetworks';
import FooterSub from './FooterSub';

import SocialNetworkModel from 'src/common/models/prismic/components/SocialNetworkModel';
import LinkModel from 'src/common/models/prismic/components/LinkModel';
import FooterColumnModel from 'src/common/models/prismic/components/FooterColumnModel';
import CountryModel from 'src/common/models/l10n/CountryModel';

import TrustpilotWidget from '../TrustpilotWidget';

import './Footer.scss';

const Footer = props => (
  <footer className="footer">
    <div className="footer-main">
      <div className="container-guttered">
        <Row colsToRowsOn="fablet-down">
          {props.columns.map((linkSet, i) => (
            <Col
              key={linkSet.title}
              className="col-1-4-on-fablet-down col-1-6-on-tablet-up">
              <Collapsible
                onToggle={props.handleToggle}
                title={linkSet.title}
                index={i}
                isOpen={props.activeLinkSetIndex === i}>
                <LinkSet
                  linkSet={linkSet}
                  country={props.country}
                  onTrackLink={props.onTrackLink}
                />
              </Collapsible>
            </Col>
          ))}
          <Col className="col-1-4-on-tablet-down col-1-2-on-tablet-up">
            <div className="footer-extras">
              {props.enableTrustPilot &&
                <TrustpilotWidget
                  templateId="microstar"
                  className="footer-trustpilot-micro-star"
                  theme="dark"
                  isComponent={false}
                />
              }
              <PaymentIcons />
              <SocialNetworks socialNetworks={props.socialNetworks} />
            </div>
          </Col>
        </Row>
      </div>
    </div>
    <FooterSub boringLinks={props.boringLinks} />
  </footer>
);

Footer.propTypes = {
  columns: PropTypes.arrayOf(FooterColumnModel.propTypes).isRequired,
  socialNetworks: PropTypes.arrayOf(SocialNetworkModel.propTypes).isRequired,
  boringLinks: PropTypes.arrayOf(LinkModel.propTypes).isRequired,
  country: CountryModel.propTypes.isRequired,
  onTrackLink: PropTypes.func.isRequired,
  handleToggle: PropTypes.func.isRequired,
  activeLinkSetIndex: PropTypes.number,
  enableTrustPilot: PropTypes.bool,
};

export default Footer;



// WEBPACK FOOTER //
// ./src/client/js/view/components/Footer/Footer.js